module.exports = __webpack_public_path__ + "static/media/train-card11.eb4fe7f9.jpg";